

module.exports = __webpack_require__.stylable.create(
    "slider2196258340",
    {"classes":{"root":"slider2196258340__root","tooltip":"slider2196258340__tooltip","track":"slider2196258340__track","inner":"slider2196258340__inner","trackFill":"slider2196258340__trackFill","thumb":"slider2196258340__thumb","thumbShape":"slider2196258340__thumbShape","tick":"slider2196258340__tick"},"vars":{},"stVars":{"tickLineWidth":"1px","tickLineHeight":"10px","tickDotSize":"3px","tickMarksGap":"12px","tooltipGap":"10px"},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/wix-ui-core/dist/src/components/slider/Slider.st.css */ 366,
    null
);
